import { daCentEu } from "../../riutilizabili/daEurCent"

class funzioniDdtUscita {
     calcPrezzoVendita( ricaricoAn = false , prod ) {
        let prodTmp = {...prod}
        let anProd = prod.Prodotti ? prod.Prodotti : prod.infoProd
        if (ricaricoAn) {
             let  prezzoUnitarioCent = parseInt(anProd.costoCent)+((parseInt(anProd.costoCent)/100)*ricaricoAn)
             prodTmp.prezzoUnitarioCent = prezzoUnitarioCent
             prodTmp.prezzoUnitario = daCentEu(prezzoUnitarioCent)
             prodTmp.tipoR = 'an'
             prodTmp.ricaricoC = ricaricoAn
             prodTmp.ricarico = ricaricoAn
        } else {
            let  prezzoUnitarioCent = parseInt(anProd.costoCent)+((parseInt(anProd.costoCent)/100)*anProd.ricarico)
            prodTmp.prezzoUnitarioCent = prezzoUnitarioCent
             prodTmp.prezzoUnitario = daCentEu(prezzoUnitarioCent)
             prodTmp.ricaricoC = anProd.ricarico
             prodTmp.ricarico = anProd.ricarico
        }
        return prodTmp
    }

}

export default new funzioniDdtUscita();
